import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Modules from "@/components/landing/Modules";
import { Spaces, HowItWorks } from "@/components/landing/Spaces";
import { About, Faq, Contact, Footer } from "@/components/landing/Sections";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#F6F8F9] overflow-x-hidden scroll-smooth" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Modules />
        <Spaces />
        <HowItWorks />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
